export enum VendedorHistoricoTipoEnum {
  TrocaEquipe = 1,
  InclusaoSimples = 2,
  CadeiaArrastada = 3,
  Remocao = 4,
  EscopoAlterado = 5,
}
